import React, { Component, PropTypes } from 'react';
import { observer, inject } from 'mobx-react';
import { observable, action, toJS } from 'mobx';
import Modal from '../../../Modal';
import Spinner from '../../../Spinner';
import Form, { FormBody, FormActions, TextInput, SelectInput, IconButton } from '../../../Form';

@inject('surveyTopicStore', 'metaDataStore')
@observer
class SurveyTopicAdd extends Component {
  static contextTypes = {
    router: PropTypes.shape().isRequired,
    notify: PropTypes.shape().isRequired,
  }

  @observable editMode = false;

  @observable item = {
    name: '',
    caption: '',
    description: '',
    type: 1,
    options: [],
  };

  slug = 'monitoring/survey/topic';
  title = '';

  componentWillMount() {
    const { params: { id }, metaDataStore } = this.props;
    metaDataStore.fetchItems();

    this.editMode = id !== 'add';
    if (this.editMode) {
      this.title = 'Edit Survey Topic';
      this.reset();
    } else this.title = 'Add Survey Topic';
  }

  @action reset = () => {
    const { params: { id }, surveyTopicStore } = this.props;
    const foundUnit = surveyTopicStore.findById(id);
    if (foundUnit) {
      this.item = foundUnit.asJson;
    }
  }

  @action onChange = (e, field) => this.item[field] = e.target.value;
  @action onChangeMetaData = (e, field) => {
    this.item[field] = [{ value: e.target.value.toString() }];
  }
  

  handleSave = (e) => {
    e.preventDefault();

    const { surveyTopicStore } = this.props;
    const { notify, router } = this.context;

    let payload = Object.assign({}, toJS(this.item));
    if (+payload.type !== 3 && +payload.type !== 6) payload.options = [];

    // console.log(payload) 
    // return

    (this.editMode ? surveyTopicStore.updateItem(payload) : surveyTopicStore.createItem(payload))
      .then(() => {
        notify.success({ message: 'Success' });
        router.push(this.slug);
      })
      .catch(err => {
        console.log(err);
        notify.error(err);
      });
  }

  _renderOptions = () => {
    return (
      <div className='bordered indented-form' style={{ width: 'unset', maxHeight: '40vh', overflowY: 'auto', marginTop: `20px` }}>
        <caption>Options</caption>
        <Form>
          <FormBody>
            {this.item.options.map((item, index) => (
              <div className='formInput flex v-center' key={`option-${index}`}>
                <input type="text" value={item.value} onChange={e => item.value = e.target.value} className='flex-grow' style={{ paddingRight: '35px' }} />
                <IconButton icon='fa fa-close' onClick={() => this.item.options.remove(item)} style={{ position: 'absolute', right: '55px' }} />
              </div>
              // <TextInput key={`option-${index}`} label='' id={`option-index`} value={item.value} onChange={e => item.value = e.target.value} />
            ))}
            <span className='button button-inactive' onClick={() => this.item.options.push({ value: '' })}>Add Option</span>
          </FormBody>
        </Form>
      </div>
    )
  }

  _renderOptionsMetaData = () => {
    const { metaDataStore } = this.props
    return (
      <Form>
        <FormBody>
          <SelectInput label={'Options'} value={this.item.options.map((item) => Number(item.value))} onChange={e => this.onChangeMetaData(e, 'options')} options={metaDataStore.items} fields={{ label: 'name', value: 'id' }} />
        </FormBody>
      </Form>
    )
  }

  render() {
    const { surveyTopicStore } = this.props;

    return (
      <Modal title={this.title} slug={this.slug} isLoading={surveyTopicStore.isLoading} isSaving={surveyTopicStore.isSaving} handleSave={this.handleSave}>
        <Form>
          <FormBody>
            <TextInput label={'Name'} value={this.item.name} onChange={e => this.onChange(e, 'name')} />
            <TextInput label={'Caption'} value={this.item.caption} onChange={e => this.onChange(e, 'caption')} />
            <TextInput label={'Description'} value={this.item.description} onChange={e => this.onChange(e, 'description')} />
            <SelectInput label={'Type'} value={this.item.type} onChange={e => this.onChange(e, 'type')} options={surveyTopicStore.types} fields={{ label: 'name', value: 'id' }} />
            {this.item.type === 3 && this._renderOptions()}
            {this.item.type === 6 && this._renderOptionsMetaData()}
          </FormBody>

          <FormActions>
            <button onClick={this.handleSave}>Save</button>
          </FormActions>
        </Form>
      </Modal>
    );
  }
}

export default SurveyTopicAdd;



// WEBPACK FOOTER //
// ./src/components/Maintenance/Survey/Topic/SurveyTopicModify.js